import React from "react";
import { ArrowUpRight } from "lucide-react";
import { services } from "../mock";
import useReveal from "../hooks/useReveal";

export default function Services() {
  const ref = useReveal();
  return (
    <section id="services" ref={ref} className="bg-[#f6f8fc] py-16 md:py-24">
      <div className="max-w-[1200px] mx-auto px-5">
        <div className="text-center mb-14 cc-reveal">
          <h2 className="font-head text-3xl md:text-4xl font-bold text-[#16244F]">Our Services</h2>
          <div className="mx-auto mt-4 h-1 w-20 rounded-full bg-[#F58220]" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((s, i) => (
            <article
              key={s.title}
              className="cc-reveal bg-white rounded-2xl overflow-hidden cc-shadow-card group flex flex-col"
              style={{ animationDelay: `${i * 0.12}s` }}
            >
              <div className="overflow-hidden h-52">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              <div className="p-7 flex flex-col flex-1">
                <h3 className="font-head text-xl font-semibold text-[#16244F] mb-3 flex items-start gap-2">
                  {s.title}
                </h3>
                <p className="text-[15px] leading-relaxed text-[#5a6274] flex-1">{s.text}</p>
                <span className="mt-5 inline-flex items-center gap-1 text-[#F58220] font-head font-semibold text-sm group-hover:gap-2 transition-all">
                  Learn more <ArrowUpRight size={16} />
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
